module.exports = __webpack_public_path__ + "img/boky_81_viridian-zelena.97b8e513.png";